import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../shared/Layout';
import PageHeader from '../shared/PageHeader';
import Icon from '../../components/tables/Icon';
import IconAdd from '../../components/icons/IconAdd';
import { getNotificationType } from '../../variables/notificationTypes';
import CommunicationCreateModal from './CommunicationCreateModal';
import * as api from './api';
import '../../css/exercise-templates.css';
import '../../css/communications.css';

// Mirrors exercise-templates/Index.jsx's list+create-modal shape exactly -
// same table/badge/empty-row classes, reused as-is.
export default function Communications() {
   const navigate = useNavigate();
   const [notifications, setNotifications] = useState([]);
   const [createOpen, setCreateOpen] = useState(false);

   const load = () => {
      api.getNotifications()
         .then((res) => setNotifications(Array.isArray(res.data) ? res.data : []))
         .catch((err) => {
            if (err.response && err.response.status === 401) navigate('/login');
         });
   };

   useEffect(load, []);

   return (
      <Layout>
         <PageHeader name='Інформація'>
            <div className='exercise-templates-header-actions'>
               <div className='exercise-templates-add-btn' onClick={() => setCreateOpen(true)} title='Створити інформацію'>
                  <IconAdd />
               </div>
            </div>
         </PageHeader>
         <main className='main-block'>
            <div className='main-content txt-c exercise-templates-page'>
               <table className='table exercise-templates-table'>
                  <thead>
                     <tr>
                        <th>Назва</th>
                        <th>Тип</th>
                        <th>Додано</th>
                        <th></th>
                     </tr>
                  </thead>
                  <tbody>
                     {notifications.map((n) => {
                        const t = getNotificationType(n.type);
                        return (
                           <tr key={n.id} className='exercise-templates-row' onClick={() => navigate('/communications/' + n.id)}>
                              <td>
                                 <div className='exercise-templates-name-cell'>
                                    <span className='exercise-templates-name-text'>{n.title}</span>
                                 </div>
                              </td>
                              <td>{t ? <span className='exercise-templates-badge' style={{ '--type-accent': t.accent }}>{t.label}</span> : n.type}</td>
                              <td>{n.dAdd ? n.dAdd.replace('T', ' ').slice(0, 16) : ''}</td>
                              <td className='exercise-templates-actions-cell' onClick={(e) => e.stopPropagation()}>
                                 <Icon mode='delete' url={'/api/notifications/' + n.id} onRefreshHundler={load} className='icon-delete' classes='icon-dimensions-big' />
                              </td>
                           </tr>
                        );
                     })}
                     {notifications.length === 0 ? (
                        <tr className='exercise-templates-empty-row'><td colSpan={4}>Ще немає жодної інформації</td></tr>
                     ) : ''}
                  </tbody>
               </table>
            </div>
         </main>
         <CommunicationCreateModal isOpen={createOpen} onClose={() => setCreateOpen(false)} />
      </Layout>
   );
}
